module.exports = __webpack_public_path__ + "media/images/off_white_half_full_circle-9d3baa4813c4d8d778e3c58b4f79fa62.svg";